import client from './client';

export const settingsApi = {
  // Get system-wide settings (admin only)
  async get() {
    const { data } = await client.get('/api/admin/settings');
    return data;
  },

  // Update system-wide settings (admin only)
  async update(updates) {
    const { data } = await client.patch('/api/admin/settings', updates);
    return data;
  },
};
